import React, { useEffect, useState } from 'react';
import { Stack, Alert } from '@mui/material';
import LabPatientCards from './LabPatientCards';
import FrameCard from 'Global/Components/CommonComponents/FrameCard/FrameCard';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useConditionalGrid from 'Global/Hooks/useConditionalGrid';
const LabPatientList = ({ listPatient }) => {
  const [openOperation, setOpenOperation] = useState(
    () => JSON.parse(sessionStorage.getItem('lab')) || []
  );

  const noDataMsg = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  // useEffect(() => {
  //   sessionStorage.setItem(
  //     'lab',
  //     JSON.stringify(openOperation)
  //   );
  // }, [openOperation]);
  const isGrid = useConditionalGrid(listPatient?.list);

  return (
    <React.Fragment>
      <Stack
        mt="1em"
        gap=".5em"
        display={isGrid ? 'grid' : ''}
        sx={{
          gridTemplateColumns: isGrid
            ? 'repeat(2, 1fr) !important'
            : '',
          gridAutoFlow: 'revert-layer',
          direction: 'rtl',
          alignItems: isGrid ? 'flex-start' : '',
        }}
      >
        {listPatient?.list?.length === 0 ? (
          <Alert
            sx={{
              mt: '1em',
              display: 'flex',
              justifyContent: 'center',
            }}
            severity="warning"
          >
            {noDataMsg}
          </Alert>
        ) : (
          listPatient?.list?.map((el) => (
            <FrameCard
              key={el.FldId}
              jsx={
                <LabPatientCards
                  content={el}
                  setOpenOperation={setOpenOperation}
                  openOperation={openOperation}
                />
              }
              cardProps={{
                padding: '.3em',
                borderRadius: '20px',
              }}
            />
          ))
        )}
      </Stack>
    </React.Fragment>
  );
};

export default LabPatientList;
